/**
 * Copyright (c) 2022 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Marcus Biesel <m.biesel@techdivision.com>
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './src/App';

const foApp = createRoot(document.getElementById('foapp'));

if (process.env.DEBUGGING_MODE === true) {
  foApp.render(
    <React.StrictMode>
      {' '}
      {/** this is only for debugging purpose * */}
      <App />
    </React.StrictMode>,
  );
} else {
  foApp.render(
    <App />,
  );
}
